import { useEffect, useState } from 'react'
import axios from 'axios'
import styles from './Footer.module.css'

const API = import.meta.env.VITE_API_GATEWAY_URL

function Footer() {
    const currentYear = new Date().getFullYear()
    const [visitas, setVisitas] = useState(null)

    useEffect(() => {
        // Registrar la visita e incrementar el contador
        axios.post(`${API}/visitas`, {}, { timeout: 4000 })
            .then(r => setVisitas(r.data.total))
            .catch(() => {})   // silencioso si falla
    }, [])

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.grid}>
                    {/* Company Info */}
                    <div className={styles.section}>
                        <h3 className={styles.title}>Ingconia</h3>
                        <p className={styles.description}>
                            Soluciones contables y tecnológicas inteligentes.
                            Transformamos tu empresa con agentes de IA personalizados.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className={styles.section}>
                        <h4 className={styles.subtitle}>Enlaces Rápidos</h4>
                        <ul className={styles.linkList}>
                            <li><a href="/" className={styles.link}>Inicio</a></li>
                            <li><a href="/servicios" className={styles.link}>Servicios</a></li>
                            <li><a href="/contacto" className={styles.link}>Contáctenos</a></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className={styles.section}>
                        <h4 className={styles.subtitle}>Contacto</h4>
                        <ul className={styles.contactList}>
                            <li>Email: contacto@ingconia.com - ingconia@outlook.com</li>
                            <li>Tel: +57 3124432678</li>
                            <li>Bogotá, Colombia</li>
                        </ul>
                    </div>
                </div>

                <div className={styles.bottom}>
                    <p className={styles.copyright}>
                        © {currentYear} Ingconia. Todos los derechos reservados.
                    </p>
                    {visitas !== null && (
                        <p className={styles.visitCounter}>
                            <span className={styles.visitDot} />
                            {visitas.toLocaleString()} visitas
                        </p>
                    )}
                </div>
            </div>
        </footer>
    )
}

export default Footer
